import { LanguageCode } from "core/constants";

const CoupangDesciption = ({ className = '' }: { className?: string }) => {
  if ((window as any)._APP_LANG !== LanguageCode.ko) {
    return null
  }
  return (
    <div className={`w-full text-[11px] text-[#FA2C2C] ${className}`}>
      ※ 이 포스팅은 쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를 제공받습니다.
    </div>
  )
};

export default CoupangDesciption;
